export const enumFieldType = {
  TEXT: "TEXT",
  DATE: "DATE",
  INTEGER: "INTEGER",
  CURRENCY: "CURRENCY",
  PICK_LIST: "PICK_LIST",
  MULTI_PICK_LIST: "MULTI_PICK_LIST",
  EMAIL: "EMAIL",
  PHONE: "PHONE",
  URL: "URL",
  TEXT_AREA: "TEXT_AREA",
};

export const configType = {
  EMBEDDED_HTML: "EMBEDDED_HTML",
  SHARED_URL: "SHARED_URL",
  EMBEDDED_SCRIPT: "EMBEDDED_SCRIPT"
};

export const userType = {
  NATIVE: "NATIVE",
  GOOGLE: "GOOGLE",
  AZURE: "AZURE",
};

export const standardFieldsOptions = [
  {
    fieldCategory: "standard",
    fieldName: "First Name",
    fieldType: enumFieldType.TEXT,
    isOptional: false,
  },
  {
    fieldCategory: "standard",
    fieldName: "Last Name",
    fieldType: enumFieldType.TEXT,
    isOptional: false,
  },
  {
    fieldCategory: "standard",
    fieldName: "Mobile Number",
    fieldType: enumFieldType.PHONE,
    isOptional: false,
  },
  {
    fieldCategory: "standard",
    fieldName: "Email",
    fieldType: enumFieldType.EMAIL,
    isOptional: false,
  },
  {
    fieldCategory: "standard",
    fieldName: "Company Name",
    fieldType: enumFieldType.TEXT,
    isOptional: true,
  },
  {
    fieldCategory: "standard",
    fieldName: "Designation",
    fieldType: enumFieldType.TEXT,
    isOptional: true,
  },
  {
    fieldCategory: "standard",
    fieldName: "Phone Number",
    fieldType: enumFieldType.PHONE,
    isOptional: true,
  },
  {
    fieldCategory: "standard",
    fieldName: "Address",
    fieldType: enumFieldType.TEXT_AREA,
    isOptional: true,
  },
  {
    fieldCategory: "standard",
    fieldName: "Website",
    fieldType: enumFieldType.URL,
    isOptional: true,
  },
  {
    fieldCategory: "standard",
    fieldName: "Industry",
    fieldType: enumFieldType.TEXT,
    isOptional: true,
  },
  {
    fieldCategory: "standard",
    fieldName: "Lead Rating",
    fieldType: enumFieldType.INTEGER,
    isOptional: true,
  },
  {
    fieldCategory: "standard",
    fieldName: "Potential Revenue(₹)",
    fieldType: enumFieldType.CURRENCY,
    isOptional: true,
  },
  {
    fieldCategory: "standard",
    fieldName: "Opportunity Amount(₹)",
    fieldType: enumFieldType.CURRENCY,
    isOptional: true,
  },
  {
    fieldCategory: "standard",
    fieldName: "Lead Source",
    fieldType: enumFieldType.TEXT,
    isOptional: true,
  },
  {
    fieldCategory: "standard",
    fieldName: "Lead Description",
    fieldType: enumFieldType.TEXT_AREA,
    isOptional: true,
  },
];

export const fieldTypes = [
  {
    value: enumFieldType.TEXT,
    label: "Text",
  },
  {
    value: enumFieldType.DATE,
    label: "Date",
  },
  {
    value: enumFieldType.INTEGER,
    label: "Integer",
  },
  {
    value: enumFieldType.CURRENCY,
    label: "Currency",
  },
  {
    value: enumFieldType.PICK_LIST,
    label: "Picklist",
  },
  {
    value: enumFieldType.MULTI_PICK_LIST,
    label: "Multi Picklist",
  },
  {
    value: enumFieldType.EMAIL,
    label: "Email",
  },
  {
    value: enumFieldType.PHONE,
    label: "Phone",
  },
  {
    value: enumFieldType.URL,
    label: "Url",
  },
  {
    value: enumFieldType.TEXT_AREA,
    label: "Text area",
  },
];